export enum AdobeAnalyticsAction {
  ASSIGNMENT_CREATED = 'assignmentCreated',
  ASSIGNMENT_STARTED = 'assignmentStarted',
  ASSESSMENT_STARTED = 'assessmentStarted',
  ASSIGNMENT_COMPLETED = 'assignmentCompleted',
  ASSESSMENT_COMPLETED = 'assessmentCompleted',
  CONTENT_VIEW = 'contentView',
  NAVIGATION_CLICK = 'navigationClick',
  NEW_PAGE = 'newPage',
  PRODUCT_FEATURE_USED = 'productFeatureUsed',
  SURVEY_SUBMISSION = 'SurveySubmission',
  GEN_AI_CONTENT_UPDATED = 'genAIContentUpdated',
  GEN_AI_CONTENT_REQUESTED = 'genAIContentRequested',
}

export enum AdobeAccessTypes {
  ANON_GUEST = 'ANON_GUEST',
  ANON_IP = 'ANON_IP',
  REG_GUEST = 'REG_GUEST',
  REG_USER = 'REG_USER'
}

export enum AdobeLoginStatus {
  LOGGED_IN = 'logged in',
  ANONYMOUS = 'anonymous'
}

export type AdobeAnalyticsVisitor = {
  accessType: string;
  loginStatus: string;
  loginSuccess: string;
  loginFailure: string;
  accountId: string;
  accountName: string;
  ipAddress: string;
  userId: string;
  departmentId: string;
  departmentName: string;
  usagePathInfo: string;
  details: string;
  accountNumber: string; // institution id
}
export type AdobeAnalyticsPage = {
  businessUnit: string;
  environment: string;
  productName: string;
  language: string;
  name: string;
  type: string;
  testId: string;
  channel: string;
  loadTime: number;
  loadTimestamp: string;
  analyticsPagename: string;
  sectionName: string;
  lastTrackedPage: string;
  cmsName: string;
  noTracking: string;
  eventName: string;
}
export type AdobeAnalyticsEducation = {
  courseId: string;
  courseName: string;
  isbn: string;
  assignmentId: string;
  assignmentName: string;
  assignmentType: string;
  moduleId: string;
  moduleName: string;
  moduleType: string;
  studentId: string;
  instructorId: string;
  semester: string;
  beforeAfterDueDate: string; // date compared to assignment due date in the format "due date +||- Int"
  assignmentNumericGrade: string;
  assignmentDuration: string;
  assignmentScore: string;
}
export type AdobeAnalyticsContent = { // for books
  entitlementType: string;
  format: string;
  id: string;
  type: string;
  details: string;
  position: string;
  publicationType: string;
  isbn: string;
  provider: string;
}

export type AdobeAnalyticsGenAI = {
  conversationId: string;
  promptCounter: number;
  input: string;
  inputSource: string;
  inputOrigin: string;
  answerDetails: string;
  citationsCount: string;
  processingTime: string;
}

export type AdobeAnalyticsPageData = {
  visitor: Partial<AdobeAnalyticsVisitor>;
  page: Partial<AdobeAnalyticsPage>;
  education: Partial<AdobeAnalyticsEducation>;
  content: AdobeAnalyticsContent[];
  survey: unknown;
  form: Partial<{
    errorType: string;
  }>;
  genAI: Partial<AdobeAnalyticsGenAI>;
}

export enum AdobeAnalyticsProductFeature {
  EXAMPLE_FEATURE_NAME = 'EXAMPLE_FEATURE_NAME',
}

export type AdobeAnalyticsActionProps = {
  action: AdobeAnalyticsAction;
  pageData: Partial<AdobeAnalyticsPageData>;
}
